import { request, RespError, handleFormatRes, formatFaceUrlNickname } from '../../utils';
import { QRY_ACT_INFO } from '../../config/url';
/** 针对分享者当前奖品状态 */
export var FriendsInfoStatus;
(function (FriendsInfoStatus) {
    /** 获得奖赏 */
    FriendsInfoStatus[FriendsInfoStatus["getAward"] = 1] = "getAward";
    /** 过期奖品信息 */
    FriendsInfoStatus[FriendsInfoStatus["expiredAward"] = 3] = "expiredAward";
    /** 在途奖品信息 */
    FriendsInfoStatus[FriendsInfoStatus["onWayAward"] = 4] = "onWayAward";
    /** 已达限额 */
    FriendsInfoStatus[FriendsInfoStatus["reachedLimit"] = 5] = "reachedLimit";
})(FriendsInfoStatus || (FriendsInfoStatus = {}));
/** 分享者奖品状态 */
export var SharePrizeInfoStatus;
(function (SharePrizeInfoStatus) {
    /** 非可兑换类型，不可兑换 */
    SharePrizeInfoStatus[SharePrizeInfoStatus["UnExchangeableInvalidType"] = 0] = "UnExchangeableInvalidType";
    /** 没获得资格，不可兑换 */
    SharePrizeInfoStatus[SharePrizeInfoStatus["UnExchangeableNoQual"] = 1] = "UnExchangeableNoQual";
    /** 已获得资格，可兑换 */
    SharePrizeInfoStatus[SharePrizeInfoStatus["Exchangeable"] = 2] = "Exchangeable";
    /** 已兑换 */
    SharePrizeInfoStatus[SharePrizeInfoStatus["Exchanged"] = 3] = "Exchanged";
})(SharePrizeInfoStatus || (SharePrizeInfoStatus = {}));
// 需要转成 int 型的 key 数组
const needParseIntKey = ['sentNum', 'totalNum', 'shareCodeSumHelp', 'helpTimes', 'help2Times', 'threshold', 'state', 'status'];
// 需要转成 date 型的 key 数组
const needParseDateKey = ['startTime', 'endTime', 'helpTime'];
// 需要转成 boolean 型的 key 数组
const needParseBoolKey = ['sameUser', 'hasHelp'];
/**
 * 分享活动首页
 *
 * 接口地址：`/app/usershare/prom_qry_act_info.cgi`
 *
 * @param
 * @returns
 */
export async function qryActInfo({ actId, shareCode }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            act_id: actId,
            share_code: shareCode,
        };
        // 接口请求
        const result = await request.get(QRY_ACT_INFO, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    needParseBoolKey,
                    transformer: (res) => {
                        const shareCodeUser = formatFaceUrlNickname(res.shareCodeFaceUrl, res.shareCodeNickName);
                        console.log('shareCodeUser: ', shareCodeUser);
                        return Object.assign(Object.assign({}, res), { shareCodeFaceUrl: shareCodeUser.faceUrl, shareCodeNickName: shareCodeUser.nickName, friendsInfo: (res.friendsInfo || []).map((ele) => (Object.assign(Object.assign({}, ele), formatFaceUrlNickname(ele.faceUrl, ele.nickName)))), phase2FriendsInfo: (res.phase2FriendsInfo || []).map((ele) => (Object.assign(Object.assign({}, ele), formatFaceUrlNickname(ele.faceUrl, ele.nickName)))), helpInfo: (res.helpInfo || []).map((ele) => (Object.assign(Object.assign({}, ele), formatFaceUrlNickname(ele.faceUrl, ele.nickName)))), isSameUser: res.sameUser });
                    },
                });
                delete res.sameUser;
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
